import { combineReducers } from 'redux';
import sessionReducer from './reducers/sessionReducer';
import levelReducer from './reducers/levelReducer';
import curriculumReducer from './reducers/curriculumReducer';
import smallItemsReducer from './reducers/smallItemsReducers';
import highlightedItemsReducer from './reducers/higlightedItemsReducer';
import hiddenItemsReducer from './reducers/hiddenItemsReducer';
import roundStatisticsReducer from './reducers/roundStatisticsReducer';
import alexReducer from './reducers/alexReducer';
import activityReducer from './reducers/activityReducer';

const store = combineReducers({
  activityReducer,
  sessionReducer,
  levelReducer,
  curriculumReducer,
  smallItemsReducer,
  highlightedItemsReducer,
  hiddenItemsReducer,
  roundStatisticsReducer,
  alexReducer,
});

export default store;
